export function youtubeEmbedUrl(value) {
  if (!value) return "";
  try {
    const url = new URL(value);
    const host = url.hostname.replace(/^www\./, "");
    if (!["youtube.com", "m.youtube.com", "youtu.be"].includes(host)) return "";

    const list = url.searchParams.get("list");
    if (list) return `https://www.youtube-nocookie.com/embed/videoseries?list=${encodeURIComponent(list)}`;

    let id = url.searchParams.get("v");
    if (!id && host === "youtu.be") id = url.pathname.split("/").filter(Boolean)[0];
    if (!id) {
      const parts = url.pathname.split("/").filter(Boolean);
      const marker = parts.findIndex((part) => ["embed", "shorts", "live"].includes(part));
      if (marker >= 0) id = parts[marker + 1];
    }
    return /^[A-Za-z0-9_-]{11}$/.test(id || "")
      ? `https://www.youtube-nocookie.com/embed/${id}`
      : "";
  } catch {
    return "";
  }
}
